/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
import { settingsArchivedConfig } from '../../config/settings.config';
export interface ISettingsArchivedPluginMethods extends IPluginMethodMap {
  getSettingsArchivedSync(args?: any): any;
}

export class SettingsArchivedPlugin implements IAgentPlugin {
  readonly methods: ISettingsArchivedPluginMethods;

  constructor() {
    this.methods = {
      getSettingsArchivedSync: this.getSettingsArchivedSync.bind(this),
    };
  }

  getSettingsArchivedSync(args?: any) {
    return {
      settings: settingsArchivedConfig,
    };
  }
}
